import { render, staticRenderFns } from "./Co-Borrowers.vue?vue&type=template&id=19c475d4&"
import script from "./Co-Borrowers.vue?vue&type=script&lang=js&"
export * from "./Co-Borrowers.vue?vue&type=script&lang=js&"
import style0 from "./Co-Borrowers.vue?vue&type=style&index=0&id=19c475d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports